// extracted by mini-css-extract-plugin
export default {"root":"c3LJmJzzWUOrIGvnvywq","loader":"UPaJUl63jCOx2JGLcpKg","dot":"NwIgT2INNU5Uk0W_Id2t","dot-soft":"FFHMEpw0FiYviue6usWM"};